export enum UserStatus {
	Deactive = 'deactivate',
	Active = 'active',
	All = 'all',
}
export const dataActive = [
	{
		title: 'Active',
		key: 1,
		value: UserStatus.Active,
	},
	{
		title: 'Deactivate',
		key: 2,
		value: UserStatus.Deactive,
	},
	{
		title: 'All',
		key: 3,
		value: UserStatus.All,
	},
];
export const dataPlan = [
	{
		title: 'Free',
		key: 1,
		value: 'free',
	},
	{
		title: 'Premium',
		key: 2,
		value: 'premium',
	},
	{
		title: 'Advanced',
		key: 3,
		value: 'advanced',
	},
	{
		title: 'Unlimited',
		key: 4,
		value: 'unlimited',
	},
	{
		title: 'Life Time',
		key: 5,
		value: 'lifetime',
	},
	{
		title: 'All Plan',
		key: 6,
		value: '',
	},
];
export const dataType = [
	{
		title: 'Google',
		key: 1,
		value: 'google',
	},
	{
		title: 'Apple',
		key: 2,
		value: 'apple',
	},
	{
		title: 'Facebook',
		key: 3,
		value: 'facebook',
	},
	{
		title: 'All Type',
		key: 4,
		value: 'all',
	},
];

export const dataPoint = [
	{
		title: '5000',
		key: 1,
		value: '5000',
	},
	{
		title: '4000',
		key: 2,
		value: '4000',
	},
	{
		title: '3000',
		key: 3,
		value: '3000',
	},
	{
		title: '2000',
		key: 4,
		value: '2000',
	},
	{
		title: '1000',
		key: 5,
		value: '1000',
	},
	{
		title: '500',
		key: 6,
		value: '500',
	},
	{
		title: 'All',
		key: 7,
		value: '',
	},
];

export const dataVerified = [
	{
		title: 'Verified',
		key: 1,
		value: 'verified',
	},
	{
		title: 'Not',
		key: 2,
		value: 'not',
	},
	{
		title: 'All',
		key: 3,
		value: '',
	},
];
